<script setup lang="ts">
const { t } = useI18n()

const components = [
    resolveComponent('HomeIntro'),
    resolveComponent('HomeInstructions'),
    resolveComponent('HomeInfos'),
]

// Seo
useSeoMeta({
    titleTemplate: () => `%s - ${t('title')}`,
    title: () => t('home.title')
})
</script>

<template>
    <PageMainContainer>
        <template v-for="(component) in components" :key="component">
            <component :is="component" />
        </template>
    </PageMainContainer>
</template>
